// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1W-QR","content":"LayoutSettings_content__1tVBR"};